








































































































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { ApiError } from '@sonicwall/unified-ui-framework/src/shared/api-service';
import { SwModal, SwModalBody } from '@libs-uuif/shared/sw-modal';
import { SwSpinningProgress } from '@libs-uuif/shared/sw-progress';
import { ManageProductUserGroupPayload, PartyMSSPResponse, ScopeProductGroup, UserGroup } from '../../types';
import { InfoState } from '@/core';
import { MswApiService } from '@/shared/msw-api-service';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { SwScrollView } from '@libs-uuif/shared/sw-scroll-view';

const cssPrefix = 'list-tenants-for-user-group';

@Component({
  components: {
    SwModal,
    SwModalBody,
    SwSpinningProgress,
    SwIcon,
    SwScrollView,
  },
})
export default class ListTenantsForUserGroup extends SwExtendedVue {
  cssPrefix = cssPrefix;

  get loadingTenantsForUserGroup() {
    return this.$store.getters['MswUserGroupStoreModule/getLoadingTenantsForUserGroup'];
  }

  get assignedProductGroup() {
    return this.tenantsForUserGroup?.assignedProductGroup || [];
  }

  get tenantsForUserGroup() {
    return this.$store.getters['MswUserGroupStoreModule/getTenantsForUserGroup'] || [];
  }

  get selectedUserGroup() {
    return this.$store.getters['MswUserGroupStoreModule/getSelectedUserGroup'] || [];
  }

  get selectedUserGroupDetail() {
    return this.$store.getters['MswUserGroupStoreModule/getSelectedUserGroupDetail'] || [];
  }

  get showRemoveTenant() {
    const { isDefaultGroup = '', isReadOnlyAccess = '', mgeProdGrpPagelink = '' } = this.selectedUserGroupDetail[0] as UserGroup || {};
    return isDefaultGroup !== 'TRUE' && isReadOnlyAccess !== 'YES' && mgeProdGrpPagelink === 'TRUE';
  }

  get showAddTenant() {
    const { productGroupName = '', isReadOnlyAccess = '', mgeProdGrpPagelink = '' } = this.selectedUserGroupDetail[0] as UserGroup;
    return productGroupName?.length > 0 && isReadOnlyAccess !== 'YES' && mgeProdGrpPagelink === 'TRUE';
  }

  get showAssignTenantModal() {
    return this.$store.getters['MswUserGroupStoreModule/getShowAssignTenantModal'];
  }

  set showAssignTenantModal(value: boolean) {
    this.$store.commit('MswUserGroupStoreModule/setShowAssignTenantModal', value);
  }

  openAssignTenantModal() {
    this.$store.commit('MswUserGroupStoreModule/setShowAssignTenantModal', true);
  }

  removeTenant(tenant: ScopeProductGroup) {
    if (this.assignedProductGroup?.length <= 1) {
      this.$store.commit('displayMessage', { infoType: 'high', infoMsg: this.$t('userGroups.ensureOneProduct') });
      return;
    }
    const payload: ManageProductUserGroupPayload = {
      bsendMail: false,
      deletedProductGroupId: tenant?.productGroupId,
      partyProductGroupList: [
        ...this.assignedProductGroup
        ?.filter((ele: ScopeProductGroup) => ele?.productGroupId !== tenant?.productGroupId)
        ?.map((ele: ScopeProductGroup) => ({
          productGroupId: ele?.productGroupId,
          partyGroupId: this.selectedUserGroup[0],
        })),
      ],
    };
    this.$store.commit('startLoading');
    MswApiService.createCustomer.postManageUserProductGroup(payload)
    .then((resp: PartyMSSPResponse) => {
      this.$store.commit('stopLoading');
      if (resp.operationStatus === 'OK') {
        this.$store.commit('MswUserGroupStoreModule/updateTenantsForUserGroup', tenant);
        this.$store.commit('displayMessage', { infoType: 'success', infoMsg: resp?.msgDesc });
      } else {
        this.$store.commit('displayMessage', { infoType: 'high', infoMsg: resp?.msgDesc });
      }
    })
    .catch((error: ApiError) => {
      this.$store.commit('stopLoading');
      const message: InfoState = { infoType: 'high', infoMsg: error?.message || 'Unknown Error' };
      this.$store.commit('displayMessage', message);
    });
  }
}
